<div class="inner-card-header">
  <div class="d-flex align-items-center">
    <h3 class="card-title">
      {{ title | translate }}
    </h3>
    <button
      mat-icon-button
      type="button"
      *ngIf="!isEditing && !isAnonymized"
      (click)="startEditing()"
      class="cursor-pointer add-icon p-btn-primary smaler-size-btn">
      <mat-icon>edit</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      *ngIf="isEditing && !isAnonymized"
      (click)="cancelEditing()"
      class="cursor-pointer add-icon p-btn-primary smaler-size-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="drivers-license-content">
  <!-- View Mode -->
  <div *ngIf="!isEditing" class="licenses-display">
    <div *ngIf="hasLicenses()" class="license-chips">
      <span *ngFor="let license of getSelectedLicensesArray()" class="license-chip">
        {{ license }}
      </span>
    </div>
    <p *ngIf="!hasLicenses()" class="no-data">{{ 'shared.noData' | translate }}</p>
  </div>

  <!-- Edit Mode -->
  <div *ngIf="isEditing" class="licenses-edit">
    <p class="edit-instructions">{{ 'dashboard.candidateDetail.driversLicenseSelect' | translate }}</p>
    <div class="license-checkboxes">
      <label
        *ngFor="let license of licenseTypes"
        class="license-checkbox"
        [class.selected]="isLicenseSelected(license)">
        <input
          type="checkbox"
          [checked]="isLicenseSelected(license)"
          (change)="toggleLicense(license)" />
        <span class="checkbox-label">{{ license }}</span>
      </label>
    </div>

    <div class="edit-actions">
      <button type="button" mat-flat-button (click)="cancelEditing()" class="p-btn-light">
        {{ 'shared.cancel' | translate }}
      </button>
      <button type="button" mat-flat-button (click)="saveChanges()" class="p-btn-primary">
        {{ 'shared.save' | translate }}
      </button>
    </div>
  </div>
</div>
